<template>
    <div class="content m-0 p-0">
        <Nav />
        <FadeTransition :duration="200" mode="out-in">
            <!-- your content here -->
            <router-view></router-view>
        </FadeTransition>
        <notifications group="foo" />
        <Footer />
    </div>
</template>

<script>
    import { FadeTransition } from 'vue2-transitions';
    import "../assets/scss/customer.scss";
    import Nav from "../components/Nav/Nav";
    import Footer from "../components/Nav/Footer";
    export default {
        components: {
            FadeTransition,
            Nav,
            Footer
        }
    };
</script>

<style scoped lang="scss">
 /*@import '../assets/scss/customer.scss';*/
</style>